import truncatemixin from './truncate.mixin'
export default {
  mixins: [truncatemixin],
  props: {
    clause: {
      type: Object,
      required: true
    }
  },
  computed: {
    truncatedText () {
      return this.truncate(this.clause.rawText || this.clause.richText)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clause.mixin.js